module.exports = __webpack_public_path__ + "static/media/personal-website-v1.e3ebe77a.png";